import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'removeLastChar'
})

export class RemoveCommaPipe implements PipeTransform {
  transform(value: any, char: any): any {
    return this.removeLastChar(value, char)

  }

  removeLastChar(value, char) {
    if (value) {
      const lastChar = value.slice(-1);
      if (lastChar === ',') {
        value = value.slice(0, -1);
      }
      return value;
    }
  }
}
